// extracted by mini-css-extract-plugin
module.exports = {"container":"globalConfirmationModal_container__1RqKa","modal":"globalConfirmationModal_modal__2y3Ui","btnContainer":"globalConfirmationModal_btnContainer__3SrHw"};